export default function copyClipboard() {
    const copyButton = document.querySelectorAll('[data-copy]');

    if(!copyButton) {
        return;
    }

    copyButton.forEach((button) => {
        button.addEventListener('click', (e) => {;
            // Create a temporary input element
            const tempInput = document.createElement('input');
            // Set its value to the current URL
            tempInput.value = button.getAttribute('data-copy');
            // Append it to the body
            document.body.appendChild(tempInput);
            // Select the input's value
            tempInput.select();
            // Copy the selected value to the clipboard
            document.execCommand('copy');
            // Remove the temporary input element
            document.body.removeChild(tempInput);

            const initialText = button.querySelector('[data-copy-initial-text]');
            const afterText = button.querySelector('[data-copy-after-text]');
        
            if (!initialText || !afterText) return;
        
            initialText.classList.add('hidden');
            afterText.classList.remove('hidden');

            setTimeout(() => {
                initialText.classList.remove('hidden');
                afterText.classList.add('hidden');
            }, 1500);
        });
    });
}